import { ArrowForward } from '@mui/icons-material';
import { Chip, type ChipProps } from '@side/pantry';

type ReferralDirectionArrowProps = {
  direction?: 'right' | 'down';
  color?: ChipProps['color'];
};

export const ReferralDirectionArrow = ({
  direction = 'right',
  color = 'default',
}: ReferralDirectionArrowProps) => {
  return (
    <Chip
      data-testid="referral-direction-arrow"
      label={
        <ArrowForward
          sx={{
            width: 18,
            display: 'flex',
          }}
        />
      }
      size="small"
      sx={{
        transform: direction === 'down' ? 'rotate(90deg)' : undefined,
        '& .MuiChip-label': {
          px: 0.25,
        },
      }}
      variant="outlined"
      color={color}
    />
  );
};
